import React, { Component } from 'react';
import { connect } from 'react-redux'

import TextInput from './controls/TextInput.jsx';

class ImageComposite extends Component {

  getImageStyle(url) {
    return {backgroundImage: 'url('+url+')'}
  }

  componentDidMount() {
    this.props.doUrlUpdate();
  }

  render() {
    return (
      <div className="Composite">
      	<div className="ImageComposite" style={this.getImageStyle(this.props.url)} />
        <TextInput name="Image URL" canCopy={true} value={this.props.url} readonly={true} />
      </div>
  	)
  }

}

const mapStateToProps = (state) => {
  return {
    url: state.url
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    doUrlUpdate: (e) => {
      dispatch({type:'URL_GENERATE'})
    }
  }
}

ImageComposite = connect(
  mapStateToProps,
  mapDispatchToProps
)(ImageComposite);


export default ImageComposite;



// WEBPACK FOOTER //
// ./src/ImageComposite.jsx